<script lang="ts" setup>
import { TuiSwitch } from '@clickbar/tailwindui-vue'

import type { PageElementDataOfType } from '../page-builder'

const data = defineModel<PageElementDataOfType<'group'>>('data', {
  required: true,
})
</script>

<template>
  <div class="flex items-center gap-2 text-sm justify-center">
    <p>Als Karte anzeigen</p>

    <TuiSwitch v-model="data.renderAsCard" short />
  </div>
</template>
